<app-dialog-layout [title]="'market_discovery.project.selection.edit-status.title' | translate">
  <cpb-form-renderer content [formKey]="formKey" [showHeader]="false"></cpb-form-renderer>

  <ng-container buttons>
    <cap-button
      icon="fal fa-times"
      styleClass="secondary"
      [label]="'button.cancel' | translate"
      (onClick)="dialogRef.close()">
    </cap-button>

    <cap-button
      styleClass="primary"
      icon="fas fa-floppy-disk"
      [label]="'market_discovery.button.save' | translate"
      (onClick)="submit()">
    </cap-button>
  </ng-container>
</app-dialog-layout>
